export type Question = {
  id: number;
  fullSentence: string;
  answer: string;
};

export function constructQuestion(id: number, row: Array<string>): Question {
  const questionColumn = 1;
  const answerColumn = 2;
  return {
    id: id,
    fullSentence: row[questionColumn],
    answer: row[answerColumn],
  };
}

export const sampleQ: Array<Question> = [
  {
    id: 1,
    fullSentence: "日本で一番高い山は何？",
    answer: "富士山",
  },
  {
    id: 2,
    fullSentence:
      "太鼓の達人の一部譜面で利用できる、1人プレイでも左右両方の太鼓で遊べるサポート機能は何？",
    answer: "パパママサポート",
  },
  {
    id: 3,
    fullSentence:
      "『Valanga』と『海神』をMixした楽曲である、BEMANI連動イベント「いちかのごちゃまぜMix Up！」でファイナルミックスサブマリンボルケーノミュージック楽曲として解禁できた曲は何？",
    answer: "VOLAQUAS",
  },
  {
    id: 4,
    fullSentence:
      "始めるのが怖いという人に対してはDJ YOSHITAKAが「ばっかお前・・・俺がついてるだろ」とメッセージを贈った、BEMANIシリーズのゲームは何？",
    answer: "REFLEC BEAT",
  },
  {
    id: 5,
    fullSentence:
      "maimaiでは1クレジット内に『テリトリーバトル』と共にプレイすると「私は今幸せよ」という称号が手に入った、CHUNITHM NEWで登場したR Sound Design feat.向日葵の楽曲は何？",
    answer: "Ring",
  },
  {
    id: 6,
    fullSentence:
      "代表曲に『迷星叫』『詩超絆』がある、メディアミックスプロジェクト「BanG Dream!」に登場するガールズバンドは何？",
    answer: "MyGO!!!!!",
  },
  {
    id: 7,
    fullSentence:
      "現在各地でロケテストが行われており、AMUSEMENT EXPO 2024でも体験できた、GITADORAシリーズの新筐体の名前は何？",
    answer: "ARENA MODEL",
  },
  {
    id: 8,
    fullSentence:
      "maimaiのMASTER譜面にはこの形のスライドが数パターン登場する、原口沙輔の楽曲『イガク』の曲中に何度も差し込まれるカタカナ1文字は何？",
    answer: "ユ",
  },
  {
    id: 9,
    fullSentence:
      "「みんなのリズム天国」では『悲しみのスコール』、「リズム天国ゴールド」では『Rainy-雨に打たれて-』というボーカル曲が使用された、リズム天国シリーズの定番ゲームは何？",
    answer: "カラテ家",
  },
];
